import React from 'react';
import { motion } from 'framer-motion';
import { RotateCcw, HelpCircle, Zap } from 'lucide-react';
const cards = [{
  icon: RotateCcw,
  title: 'Infinite Mental Loops',
  desc: "The same conversation replaying on a loop. The same question with no answer. You're not processing — you're spiraling. And every loop drains more energy than the last."
}, {
  icon: HelpCircle,
  title: 'Trauma vs. Intuition',
  desc: 'Is this a red flag from God — or a wound from your past? When trauma and intuition sound identical, every decision feels like a gamble with your future.'
}, {
  icon: Zap,
  title: 'Pressure, Not Peace',
  desc: "Decisions made at 2 AM under emotional pressure are not discernment. They're survival responses. And survival mode was never designed to guide your relationships."
}];
export function PainSection() {
  return <section className="py-24 md:py-32 px-4 bg-navy watermark-bg" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-169">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-4" data-id="element-170">
            Overthinking Is Not Discernment.
            <br className="hidden md:block" data-id="element-171" />
            <span className="text-gold" data-id="element-172">It's Paralysis.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-173">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.12
          }} className="bg-white/[0.03] p-8 rounded-2xl border border-white/[0.06]" data-id="element-174">
                <div className="w-12 h-12 rounded-xl bg-gold/10 flex items-center justify-center mb-6" data-id="element-175">
                  <Icon className="w-6 h-6 text-gold" data-id="element-176" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-cream" data-id="element-177">
                  {card.title}
                </h3>
                <p className="text-cream/60 leading-relaxed" data-id="element-178">{card.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}